export const RESET = 'EXSBINVOICESTATUS_UPDATE_RESET'
export const SET_ERROR = 'EXSBINVOICESTATUS_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBINVOICESTATUS_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBINVOICESTATUS_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBINVOICESTATUS_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBINVOICESTATUS_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBINVOICESTATUS_UPDATE_UPDATE_RETRIEVED'
